import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Menu, { MenuItem } from '../common/Menu';
import { routesConfig } from '../../routes';
import { useTheme } from '../theme/useTheme';
import { LANGUAGES, useLanguage, useTranslation } from '../../i18n/LanguageProvider';

export default function Header() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { mode, setMode, theme } = useTheme();
  const { language, setLanguage } = useLanguage();
  const { t } = useTranslation();

  const isCurrent = path => pathname === path || (path !== '/' && pathname.startsWith(`${path}/`));

  return (
    <header className="site-header">
      <div className="container">
        <Link to="/" className="site-brand" onClick={() => setMenuOpen(false)}>
          Frederico Schardong<span>PhD</span>
        </Link>

        <button
          type="button"
          className="navbar-toggler btn"
          aria-controls="site-navigation"
          aria-expanded={menuOpen}
          aria-label={menuOpen ? t('accessibility.closeMenu') : t('accessibility.openMenu')}
          onClick={() => setMenuOpen(open => !open)}
        >
          <i className="icon-bars" aria-hidden="true"></i>
        </button>

        <nav id="site-navigation" className={`navbar-collapse${menuOpen ? ' is-open' : ''}`}
          aria-label={t('nav.home')}>
          <ul className="navbar-nav">
            {routesConfig.filter(({ label }) => label).map(({ path, label, translationKey, href }) => (
              <li key={label}>
                {href ? (
                  <a className="nav-link" href={href} target="_blank" rel="noopener noreferrer">
                    {t(`nav.${translationKey || label.toLowerCase()}`)}
                  </a>
                ) : (
                  <Link
                    className={`nav-link${isCurrent(path) ? ' active' : ''}`}
                    to={path}
                    aria-current={isCurrent(path) ? 'page' : undefined}
                    onClick={() => setMenuOpen(false)}
                  >
                    {t(`nav.${translationKey || label.toLowerCase()}`)}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="header-controls">
          <Menu label={t('language')} trigger={language === LANGUAGES.PT_BR ? 'PT' : 'EN'}>
            <MenuItem onClick={() => setLanguage(LANGUAGES.EN)} selected={language === LANGUAGES.EN}>
              {t('languages.en')}
            </MenuItem>
            <MenuItem onClick={() => setLanguage(LANGUAGES.PT_BR)} selected={language === LANGUAGES.PT_BR}>
              {t('languages.pt')}
            </MenuItem>
          </Menu>

          <Menu
            label={`${t('theme.select')}. ${t('theme.current')}: ${theme}`}
            trigger={<i className={theme === 'dark' ? 'icon-moon' : 'icon-sun'} aria-hidden="true"></i>}
          >
            <MenuItem onClick={() => setMode('light')} selected={mode === 'light'}>
              <i className="icon-sun" aria-hidden="true"></i> {t('theme.light')}
            </MenuItem>
            <MenuItem onClick={() => setMode('dark')} selected={mode === 'dark'}>
              <i className="icon-moon" aria-hidden="true"></i> {t('theme.dark')}
            </MenuItem>
            <MenuItem onClick={() => setMode('auto')} selected={mode === 'auto'} label={t('theme.system')}>
              <i className="icon-contrast" aria-hidden="true"></i> {t('theme.auto')}
            </MenuItem>
          </Menu>
        </div>
      </div>
    </header>
  );
}
